import React from "react";
import { Helmet } from "react-helmet";
import "./AISolutions.css";

function AISolutions() {
  return (
    <div className="ai-page">

      {/* ✅ SEO */}
      <Helmet>
        <title>AI Solutions Company in Dubai | AI Development USA & Saudi Arabia</title>
        <meta
          name="description"
          content="Leading AI solutions company in Dubai providing AI development, automation, chatbots, machine learning & business intelligence services for USA, Dubai and Saudi Arabia clients."
        />
        <meta
          name="keywords"
          content="AI solutions Dubai, AI development Dubai, artificial intelligence company UAE, AI company USA, AI services Saudi Arabia"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="ai-hero">
        <h1>AI Solutions Company in Dubai</h1>
        <p>
          We deliver intelligent AI solutions in Dubai, USA, and Saudi Arabia 
          to automate businesses, reduce costs, and increase productivity.
        </p>
        <a href="/contact" className="ai-btn">Get Free Consultation</a>
      </section>

      {/* Services */}
      <section className="ai-services">
        <h2>Our AI Development Services</h2>

        <div className="ai-grid">
          <div className="ai-card">
            <h3>AI Chatbots & Virtual Assistants</h3>
            <p>
              Custom AI chatbots for websites and apps helping Dubai businesses
              automate customer support 24/7.
            </p>
          </div>

          <div className="ai-card">
            <h3>Machine Learning Solutions</h3>
            <p>
              Predictive analytics, recommendation engines, and smart automation
              for companies in USA and Saudi Arabia.
            </p>
          </div>

          <div className="ai-card">
            <h3>Business Process Automation</h3>
            <p>
              Reduce operational costs with AI automation systems designed for 
              enterprises in Dubai and UAE.
            </p>
          </div>

          <div className="ai-card">
            <h3>AI Integration</h3>
            <p>
              Seamless AI integration into existing ERP, CRM, and business platforms.
            </p>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="ai-pricing">
        <h2>AI Development Pricing (AED)</h2>

        <div className="ai-grid">
          <div className="ai-card">
            <h3>Starter AI Package</h3>
            <h4>AED 8,000 – 15,000</h4>
            <p>Basic chatbot or automation system for startups in Dubai.</p>
          </div>

          <div className="ai-card">
            <h3>Business AI Package</h3>
            <h4>AED 20,000 – 45,000</h4>
            <p>Advanced AI integration & machine learning models.</p>
          </div>

          <div className="ai-card">
            <h3>Enterprise AI Solution</h3>
            <h4>AED 60,000+</h4>
            <p>Custom AI architecture for large enterprises in UAE & USA.</p>
          </div>
        </div>
      </section>

      {/* UAE Testimonials */}
      <section className="ai-testimonials">
        <h2>What Our UAE Clients Say</h2>

        <div className="ai-grid">
          <div className="ai-card">
            <p>
              “Their AI chatbot increased our Dubai customer response rate by 65%.
              Professional and reliable team.”
            </p>
            <strong>– Ahmed R., Retail Business Owner, Dubai</strong>
          </div>

          <div className="ai-card">
            <p>
              “We implemented AI automation for our logistics company in UAE 
              and reduced operational costs significantly.”
            </p>
            <strong>– Khalid M., Operations Manager, Sharjah</strong>
          </div>

          <div className="ai-card">
            <p>
              “Excellent AI development service for our USA-based SaaS platform.”
            </p>
            <strong>– Jessica L., CEO, California</strong>
          </div>
        </div>
      </section>

      {/* Google Business Section */}
      <section className="ai-google">
        <h2>Trusted AI Company in Dubai, UAE</h2>
        <p>
          We proudly serve clients in Dubai, Abu Dhabi, Sharjah, USA, and Saudi Arabia. 
          Check our Google Business Profile for verified UAE client reviews.
        </p>
        <a
          href="https://maps.app.goo.gl/wRSiYJk2KqDbuebU6"
          target="_blank"
          rel="noopener noreferrer"
          className="ai-btn"
        >
          View Google Reviews
        </a>
      </section>

      {/* CTA */}
      <section className="ai-cta">
        <h2>Ready to Implement AI in Your Business?</h2>
        <p>
          Partner with a leading AI solutions company in Dubai delivering intelligent
          systems for businesses in UAE, USA, and Saudi Arabia.
        </p>
        <a href="/contact" className="ai-btn">Start Your AI Project</a>
      </section>

    </div>
  );
}

export default AISolutions;